<template>
    <div class="mr-1" style="overflow-y: auto;min-height:560px;">

        <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex align-items-center mb-2" style="gap:1rem">
                <div class="px-4 fs-16 fw-500 ml-1  " style="color: #00448b;">
                    <span class="highlighted">Archive Tickets({{ pagination.total }})</span> 
                </div>
            </div>
            <div class="mb-2">
                <button class="btn btn-filter btn-smm ml-2" @click="showFilters()">
                    <img src="/static/images/new-theme2024/newfilter-icon.png" width="28px" alt="filter">
                    <span class="text-white ml-1 hidden-sm-down fs-14 fw-500">Filter</span>
                </button>
            </div>
        </div>
        <div class="pb-3 pl-2 pr-3 position-content-main" style="min-height:fit-content;">
            <div class="d-flex flex-wrap justify-content-between">
                <div class="breadcrumbnewtheme px-4 mt-3">
                    <div class="pre gap-0p5 fw-500">
                        Archive Ticket
                    </div>
                    <span >/</span>
                    <!-- <div class="pre gap-0p5 fw-500">
                        Overall
                    </div>
                    <span style="color:#b2bec3">/</span> -->
                    <span class="pre gap-0p5 fw-500 text-capitalize">
                        List View
                    </span>
                </div>
                <div class="mt-3 align-items-center">
                    <!-- <div class="hor-line"></div> -->
                    <button @click="firstPage()" :disabled="pagination.skip == 0" class="pointer mr-2 pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <!-- <i class="icon-chevron-double-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" :disabled="pagination.skip == 0" class="pagination-list-single pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <!-- <i class="icon icon-chevron-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{pagination.total>pagination.skip+pagination.limit?pagination.skip+pagination.limit:pagination.total}} of {{pagination.total}}</span>
                    <button @click="nextPage()" :disabled="pagination.skip_temp >= pagination.total || pagination.temp_total == pagination.total" class="pagination-list-single pointer mr-2">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <!-- <i class="icon icon-chevron-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" class="pointer pagination-list" :disabled ="pagination.temp_total == pagination.total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <!-- <i class="icon-chevron-double-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                </div>
            </div>
            <!-- <hr style="border-bottom: 2px solid #636e71;"> -->
            <div class="vendor-list mt-1 height-fit-content bg-gold">
                <div class="d-flex flex-wrap justify-content-between mb-1 mt-2"  v-if="tabs.length>0" style="gap:1rem">
                    <div class="w-100 inner-line-hr-tag ml-2 mr-1"></div>
                    <div class="d-flex align-items-center px-2" style="gap:.5rem;flex-wrap: wrap">
                        <span class="fw-600 whitespace-nowrap">Sort by:</span>
                        <div class="d-flex align-items-center justify-content-between width-fit-content pointer tags-custom mr-3" v-for="(f, f_index) in tabs" :key="f_index" v-if="f_index<=4" :class="{ 'selected-tag': f_index === selectedTicketIndex }">
                            <span class="ml-2 fw-500 text-nowrap text-black fs-12" :class="{ 'selected-tag': f_index === selectedTicketIndex }" @click="selectTicket(f, f_index)">Ticket #{{f.ticket_number}}</span> 
                            <el-tooltip class="item" effect="dark" content="Close" placement="top">
                                <i class="icon icon-close text-black fs-18 pointer " :class="{ 'selected-tag': f_index === selectedTicketIndex }" @click="removeTicketTab(f_index)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="w-100 inner-line-hr-tag ml-2 mr-1"></div>
                </div>
                <div class="p-0 mt-3">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                            <ArchieveTickets 
                                :allArchieveTickets="allArchieveTickets" @viewArchiveTickets="viewArchiveTickets" 
                                :list_id_index="list_id_index" :ajaxCallInProgress="ajaxCallInProgress"
                                @updateTabsForList="updateTabsForList"
                            />
                        </div>
                        <div class="col-lg-8 col-md-8 col-sm-6 view-box scroll-new" style="overflow-y: auto !important;height: max-content !important;">
                            <archive-ticket-details :showDetails="showDetails" @UpdateArchiveListOnStatusChange="UpdateArchiveListOnStatusChange" :is_ticket_not_found="is_ticket_not_found" :list_loader="ajaxCallInProgress"></archive-ticket-details>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data 
                    @hideFilters="hideFilters" :showfilterData="showfilterData" 
                    @appliedFilter="appliedFilter"
                >
                </filter-data>
            </div>
        </div>
	</div>
</template>
<script>
import Vue from "vue";
import { EventBus } from '../eventBus/nav-bar-event'
import archieve from "../mixins/archieve";
const ListView = () => import("./ListView.vue");
const ArchiveTicketDetails = () => import("./TicketDetails.vue")
const ArchieveTickets =() => import('../ArchieveTickets/ListView.vue')
const FilterData = () => import('./FilterData')
export default {
    mixins: [archieve],
    data(){
        return{
            display_filters: false,
            hide_filters: false,
            list: [],
            selected: "",
            selected_name: "manage-ticket",
            totalTickets: 0,
            selected_ticket_id: "",
            triggerZinde:false,
            showDetails: '',
            pagination:{
                skip:0,
                limit:10,
                total:0,
                temp_total:0,
                skip_temp: 0,
            },
            search_key: '',
            passed_key: {
                key: 'created_date',
                value: -1
            },
            showfilterData:{
                created_templates: [],
                approvers: [],
                created_tags: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:''
            },
            filterData:{
                created_templates: [],
                created_tags: [],
                approvers: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:''
            },
            ajaxCallInProgress: false,
            allArchieveTickets: [],
            list_id_index: 0,
            is_ticket_not_found: false,
            tabs: [],
            selectedTicketIndex: 0,
        }
    },
    components:{
        ListView,
        ArchiveTicketDetails,
        ArchieveTickets,
        FilterData
    },
    methods:{
        updateTabsForList(){
            if(localStorage.getItem('listData')){
                this.tabs = JSON.parse(localStorage.getItem('listData'))
            }
        },
        removeTicketTab(index){
            if(localStorage.getItem('listData')){
                this.tabs = JSON.parse(localStorage.getItem('listData'))
                this.tabs.splice(index, 1)
                if(this.tabs.length == 0){
                    this.list_id_index = 0
                    this.showDetails = this.allArchieveTickets[this.list_id_index]
                    this.showDetails = this.allArchieveTickets[0]
                } else {
                    if(index - 1 < 0){
                        this.showDetails = this.tabs[index || 0]
                    } else {
                        this.showDetails = this.tabs[index-1 || 0]
                    }
                }
                localStorage.setItem('listData', JSON.stringify(this.tabs))
            }
        },
        selectTicket(ticket, index) {
        this.selectedTicketIndex = index;
        this.viewTicketFromTab(ticket);
    },
        viewTicketFromTab(ticket){
            this.showDetails = ticket
        },
        showFilters(){
            EventBus.$emit('ZindexChangeStart')
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            this.display_filters = false
            setTimeout(() => {
                this.hide_filters = false
            }, 500);
        },
        UpdateArchiveListOnStatusChange(){
            this.list_id_index = 0
            if(this.allArchieveTickets.length > 0){
                this.showDetails = this.allArchieveTickets[this.list_id_index]
            }
            this.getTableData()
        },
        viewArchiveTickets(ticket_details){
            this.list_id_index = ticket_details.index
            this.showDetails = ticket_details.ticket
        },
        appliedFilter(data){
            this.filterData = {
                created_templates: data.value.created_templates,
                approvers: data.value.approvers,
                created_tags: data.value.created_tags,
                assigned_to:data.value.assigned_to,
                branch:data.value.branch,
                company_name:data.value.company_name,
                created_date:data.value.created_date,
                department:data.value.department,
                last_modified_date:data.value.last_modified_date,
                priority:data.value.priority,
                product:data.value.product,
                status:data.value.status,
                ticket_number:data.value.ticket_number,
                template:data.value.template,
                assign_to_whom:data.value.assign_to_whom,
                behalf_of_whom:data.value.behalf_of_whom,
                behalf_selected:data.value.behalf_selected,
                ticket_type:data.value.ticket_type
            }
            this.showfilterData = {
                created_templates: data.value1.created_templates,
                created_tags: data.value1.created_tags,
                approvers: data.value1.approvers,
                assigned_to:data.value1.assigned_to,
                branch:data.value1.branch,
                company_name:data.value1.company_name,
                created_date:data.value1.created_date,
                department:data.value1.department,
                last_modified_date:data.value1.last_modified_date,
                priority:data.value1.priority,
                product:data.value1.product,
                status:data.value1.status,
                ticket_number:data.value1.ticket_number,
                template:data.value1.template,
                assign_to_whom:data.value1.assign_to_whom,
                behalf_of_whom:data.value1.behalf_of_whom,
                behalf_selected:data.value1.behalf_selected,
                ticket_type:data.value.ticket_type
            }
            this.getTableData()
        },
        firstPage(){
            this.pagination.temp_total = 0
            this.pagination.skip = 0
            this.pagination.limit = 10
            this.pagination.skip_temp = 0
            this.getTableData()
        },
        lastPage(){
            this.pagination.skip_temp = 0
            this.pagination.skip = 0
            this.pagination.temp_total = this.pagination.total
            let no_of_pages = Math.ceil(this.pagination.total/this.pagination.limit)
            this.pagination.skip_temp = (no_of_pages * this.pagination.limit) - this.pagination.limit
            if (this.pagination.skip_temp >= this.pagination.total) {
                return;
            }
            this.pagination.skip = this.pagination.skip_temp
            this.getTableData()
        },
        nextPage() {
            this.pagination.skip_temp = this.pagination.skip + this.pagination.limit > this.pagination.total ? this.pagination.total : this.pagination.skip + this.pagination.limit;
            this.pagination.temp_total = this.pagination.skip_temp
            if (this.pagination.skip_temp >= this.pagination.total) {
                return;
            }
            this.pagination.skip = this.pagination.skip_temp;
            this.getTableData()
        },
        previousPage() {
            this.pagination.temp_total = 0
            this.pagination.skip_temp = 0
            if (this.pagination.skip == 0) {
                return;
            }
            this.pagination.skip = this.pagination.skip - this.pagination.limit <= 0 ? 0 : this.pagination.skip - this.pagination.limit;
            this.getTableData()
        },
        addTicket(ticket) {
            var ticket_id = ticket.ticket_id;
            var ticket_number = ticket.ticket_number;
            var is_parent_ticket = ticket.is_parent_ticket || false
            var subject = ticket.subject || ''
            var is_present = false;
            var obj = {};
            this.list.forEach(function(tab) {
                if (tab.ticket_id == ticket_id) {
                    is_present = true;
                    obj = tab;
                    return;
                }
            });
            if (is_present) {
                this.selected = this.list.indexOf(obj);
                this.selected_name = obj.value;
            } else {
                if (this.list.length >= 7) {
                    this.list.splice(this.list.length, 0, {
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject
                    });
                } else {
                    this.list.push({
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject
                    });
                }
                this.selected_name = "ticket-details";
                this.$router.push({ path: "/archievetickets/" + ticket_id });
                this.totalTickets++;
                this.selected = this.list.length - 1;
            }
        },
        select_tab(item, obj){
            var prev = this.selected;
            this.selected = item;
            this.selected_ticket_id = obj.ticket_id;
            if (item >= 7) {
                this.selected = prev;
                var x = this.list[prev];
                this.list[prev] = obj;
                this.list[item] = x;
            }
            this.selected_name = obj.value;
            if (obj.value == "ticket-details") {
                this.$router.push({ path: "/archievetickets/" + obj.ticket_id }).catch(()=>{});
                EventBus.$emit('ReloadDetailsDataById',obj.ticket_id)
            } else if (obj.value == "manage-ticket") {
                this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
            }
        },
        remove_tab(index,e){
            this.totalTickets = this.totalTickets - 1;
            e.stopImmediatePropagation();
            Vue.delete(this.list, index);
            if (this.selected == index) {
                this.selected = index - 1;
            } else if (this.selected > index) {
                this.selected = this.selected - 1;
            }
            if(this.selected < 0) this.selected = 0
            if(this.list && this.list.length){
                this.selected_name = this.list[this.selected].value;
            }
            if (this.selected_name == "ticket-details") {
                if(this.list && this.list.length){
                    this.$router.push({
                        path: "/archievetickets/" + this.list[this.selected].ticket_id
                    }).catch(()=>{});
                    EventBus.$emit('ReloadDetailsDataById', this.list[this.selected].ticket_id)
                }else{
                    this.$router.push({ path: "/archievetickets" }).catch(()=>{});
                    this.selected_name = "manage-ticket"
                }
            } else if (this.selected_name == "manage-ticket") {
                this.$router.push({ path: "/archievetickets" }).catch(()=>{});
            }
        },
        gotoManageTicket(){
            if(String(this.$route.path).startsWith('/pm')) {
                this.$router.push({
                    path: "/pm/archievetickets/"
                }).catch(()=>{});
            }
            else {
                if(this.$route.query.view_ticket) {
                    this.$router.push({ path: "/archievetickets", query: {'view_ticket': this.$route.query.view_ticket} })
                } else {
                    this.$router.push({ path: "/archievetickets" }).catch(()=>{});
                }
            }
            this.selected_name = "manage-ticket"
        },
        async getTableData(){
            try {
                this.ajaxCallInProgress = true
                this.allArchieveTickets = []
                let params = {
                    skip: this.pagination.skip || 0,
                    limit: this.pagination.limit,
                    search_key: this.search_key.trim(),
                    sort_key: this.passed_key.key,
                    is_mobile:false,
                    filters:{
                        sort_value: this.passed_key.value,
                        assigned_to:{
                            select_all:false,
                            to:this.filterData.assign_to_whom,
                            value:this.filterData.assigned_to
                        },
                        branch:{
                            value:this.filterData.branch
                        },
                        company_name:{
                            value:this.filterData.company_name
                        },
                        date_range:{
                            created_date:this.filterData.created_date,
                            modification_date:this.filterData.last_modified_date,
                        },
                        department:{
                            value:this.filterData.department
                        },
                        priority:{
                            value:this.filterData.priority
                        },
                        product:{
                            select_all:false,
                            value:this.filterData.product
                        },
                        ticket_number:{
                            select_all:false,
                            value:this.filterData.ticket_number
                        },
                        on_behalf_of:{
                            for:this.filterData.behalf_of_whom,
                            select_all:false,
                            value:this.filterData.behalf_selected
                        },
                        tag :{
                            select_all: false,
                            value: this.filterData.created_tags,
                        },
                        approvers: {
                            select_all: false,
                            value: this.filterData.approvers
                        },
                        ticket_type:this.filterData.ticket_type,
                        template: {
                            select_all: false,
                            value: this.filterData.created_templates,
                        }
                    }
                }
                if(params.filters.assigned_to.value.length){
                  params.filters.assigned_to.select_all = false
                }else{
                    params.filters.assigned_to.select_all = true
                }
                if(params.filters.on_behalf_of.value.length){
                   params.filters.on_behalf_of.select_all = false
                }else{
                    params.filters.on_behalf_of.select_all = true
                }
                if(params.filters.product.value.length){
                    params.filters.product.select_all = false
                }else{
                    params.filters.product.select_all = true
                }
                if(params.filters.tag.value.length){
                    params.filters.tag.select_all = false
                }else{
                    params.filters.tag.select_all = true
                }
                if(params.filters.ticket_number.value.length){
                    params.filters.ticket_number.select_all = false
                }else{
                    params.filters.ticket_number.select_all = true
                }
                if(params.filters.template.value.length){
                    params.filters.template.select_all = false
                }else{
                    params.filters.template.select_all = true
                }
                if(params.filters.approvers.value.length){
                    params.filters.approvers.select_all = false
                }else{
                    params.filters.approvers.select_all = true
                }
                let res = await this.getAllArchieveTickets(params)
                this.allArchieveTickets = res.response.archive_tickets
                this.list_id_index = 0
                if(res.response.archive_tickets.length != 0) {
                    this.showDetails = this.allArchieveTickets[this.list_id_index]
                    this.is_ticket_not_found = false
                }
                else this.is_ticket_not_found = true
                this.pagination.total = res.response.total_no_of_tickets
                this.ajaxCallInProgress = false
            } catch (reason) {
                console.log(reason);
            }
        },
    },
    mounted(){
        EventBus.$on('tabactivateArchieve',ticket=>{
            this.addTicket(ticket)
        })
        EventBus.$on('ReopenedSuccess',index=>{
            this.list.forEach((el,lIndex)=>{
                if(lIndex == index){
                    this.list.splice(lIndex,1)
                    this.selected_name = "manage-ticket"
                    EventBus.$emit('ReopenedSuccessUpdate')
                }
            })
        })
        if(localStorage.getItem('listData')){
            this.tabs = JSON.parse(localStorage.getItem('listData'))
        }
        EventBus.$on('updateArchieveView',()=>{
            this.list = []
            this.selected_name = "manage-ticket"
        })
        if(this.$route.name == 'ArchieveListView'){
            if(this.selected_name == 'manage-ticket' && this.$route.params && this.$route.params.id != ''){
                this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
            }
        }
        if(localStorage.getItem('StoreFilterData')){
            let FilterData = JSON.parse(localStorage.getItem('StoreFilterData'));
            this.showfilterData = FilterData.showfilterData;
            this.filterData = FilterData.filterData;
        }
        this.getTableData()
    },
    computed:{
        getSkipCount(){
            if(this.pagination.total == 0) {
                return 0
            } else {
                let skip_count = this.pagination.skip>this.pagination.total?this.pagination.total:this.pagination.skip+1;
                return skip_count;
            }
        },
    },
    destroyed(){
        EventBus.$off('tabactivateArchieve')
        localStorage.removeItem('listData')
    }
}
</script>
<style scoped>
.selected-tag {
    background-color: #00448b !important; /* or any other styling you want */
    color: white !important; /* change text color to white for better contrast */
}
.ticket_list{
    padding-left: 0px;
    display: inline-block;
    flex-direction: row;
}
.ticket_list_number{
    list-style: none;
    background-color: #ffffff;
    padding: 5px 10px;
    border-radius: 5px;
    max-width: 150px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
}
.ticket_list_number i{
    border:1px solid #000000;
    border-radius:50px;
    color: #000000;
}
.ticket_list_number-selected{
    background-color: #005dae !important;
    color: #fff !important;
}
.ticket_list_number-selected .li_span{
    color: #fff !important
}
.ticket_list_number-selected i{
    color: #fff !important;
    border:1px solid #fff !important;
}
.ticket_list_number-selected i.no-border{
    border: none !important;
}
.divide_line{
    border: 1px solid #005dae;
    margin-left: 10px;
    margin-right: 10px;
    height: 30px;
}
.dropbtn {
    background-color: #005dae;
    color: #fff;
    cursor: pointer;
    margin-top: -5px;
    border-radius: 5px;
    line-height: 33px;
}
.dropbtn:hover {
    background-color: #005dae;
}
.dropbtn i {
    color: #fff !important;
}
.dropdown {
    position: relative;
    display: inline-block;
}
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fff;
    /* min-width: 180px; */
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius:5px;
    z-index: 1;
    right: 0px;
    top: 32px;
}
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed {
    width: 100%;
    vertical-align: middle;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
    background-color: #eee;
}
.dropdown:hover .dropdown-content {
    display: block;
}
.res-width{
    min-width:60%
}
@media (max-width: 580px) {
    .vendor-list{
        height: 100% !important;
    }
    .left-list{
        height: 500px !important;
    }
}
/* @media screen and (max-width:1347px) {
    .res-width{
        min-width:75%
    }
} */
@media screen and (max-width:1011px) {
    .res-width{
        min-width:100%;
        flex-wrap: wrap
    }
}
.scm-filters {

    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
    overflow: auto;
    max-width: 768px;
    top: 100px;
    /* background: #e6ecff !important; */
    position: fixed;
}
    .overflow-visible {
    z-index: 999 !important;
    right: 0 !important;
    width: 650px;
    }
.hor-line {
  width: 2px;
  height: 30px;
  background-color: #1b57ad;
}
.height-fit-content{
    height: fit-content;
}
.gap-0p5{
    gap: 0.5rem;
}
.fs-2rem{
    font-size: 2rem;
}
.position-content-main{
    border-radius: 25px;
    background-color: #f0ddb7;
}
</style>